import { Controller } from "@hotwired/stimulus"

// Shows/hides the sticky CTA bar based on product section visibility.
// Bar is visible at the top (before products) and after scrolling past products.
// Hidden while the product cards section is in the viewport.
export default class extends Controller {
  static targets = ["products", "bar"]

  connect() {
    if (!this.hasProductsTarget || !this.hasBarTarget) return

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Products visible — hide sticky CTA
            this.barTarget.classList.add("translate-y-full")
            this.barTarget.classList.remove("translate-y-0")
          } else {
            // Products not visible — show sticky CTA
            this.barTarget.classList.remove("translate-y-full")
            this.barTarget.classList.add("translate-y-0")
          }
        })
      },
      { threshold: 0.1 }
    )

    this.observer.observe(this.productsTarget)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
